import React from "react";
import { render } from "react-dom";
import ResearcherAppWrapper from "../components/researcher/ResearcherAppWrapper";

document.addEventListener("DOMContentLoaded", () => {
    render(
        <ResearcherAppWrapper />,
        document.body.appendChild(document.createElement("div"))
    )
}, { once: true });


